
import CarParkApi from './src/CarParkApi'
import BaseDataApi from './src/BaseDataApi'
import LedApi from './src/LedApi'
import AlarmApi from './src/AlarmApi'
import ExecutTaskApi  from './src/ExecutTask'
import UniformConfigApi from './src/UniformConfigApi'

let apis = {
    CarParkApi,
    BaseDataApi,
    LedApi,
    AlarmApi,
    ExecutTaskApi,
    UniformConfigApi
};

export default apis;
